// @flow
const login = (token: string) => ({
  type: 'login',
  payload: {
    token,
  },
});

const logout = () => ({
  type: 'logout',
});

export { login, logout };



// WEBPACK FOOTER //
// ./src/actions/index.js